import { createUseFeatureFlagsSelector } from '@montugroup/circuit-shared/hooks/featureFlags/createUseFeatureFlagsSelector';
import useFeatureFlags from './useFeatureFlags';

export const useFeatureFlagsSelector = createUseFeatureFlagsSelector(useFeatureFlags);
